const ExternalLink = ({ href, children, className = '', maxWidth = '300px' }) => {
    const linkStyles = {
        maxWidth,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline-block',
    };

    // Function to validate and format URL
    const formatUrl = (url) => {
        if (!url) return '';

        // Remove leading/trailing whitespace
        const trimmedUrl = url.trim();

        // Check if URL is valid
        try {
            // Try to construct URL - will throw error if invalid
            new URL(trimmedUrl);
            return trimmedUrl;
        } catch {
            // If no protocol specified, prepend https://
            if (!trimmedUrl.match(/^https?:\/\//i)) {
                try {
                    new URL(`https://${trimmedUrl}`);
                    return `https://${trimmedUrl}`;
                } catch {
                    return null;
                }
            }
            return null;
        }
    };

    const formattedUrl = formatUrl(href);

    // If URL is invalid, just render as text
    if (!formattedUrl) {
        return <span className={className} style={{...linkStyles}}>{children || href}</span>;
    }

    return (
        <a
            href={formattedUrl}
            className={className}
            style={{...linkStyles}}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Visit ${children || href} (opens in new tab)`}
        >
            {children || href}
        </a>
    );
};

export default ExternalLink;
